import React, { Component } from 'react';
import { Row, Col, Button, NavLink } from 'reactstrap';
import Header from '../header';
import Footer from '../footer';
import * as firebase from "firebase";

class ProductDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProduct: {},
            loading: true
        }
    }

    componentWillMount() {
        this.setState({
            selectedProduct: this.props.location.state.product
        })
    }

    openCheckout() {
    const { selectedProduct } = this.state;
    const currentUser = firebase.auth().currentUser
    const options = {
        "key": "rzp_test_NLTPbSULjHYddF",
        "amount": (selectedProduct.amount || 10) * 100, // 2000 paise = INR 20, amount in paisa
        "name": "Sell and Buy",
        "description": "Purchase Description",
        "image": "/your_logo.png",
        "handler": async (razorpayData) => {
            const cartKey = firebase.database().ref().child(`carts/${currentUser.uid}`).push().key;
            let updates = {};
            updates[`/carts/${currentUser.uid}/${cartKey}` ] = {
                userId: currentUser.uid,
                razorpayData: razorpayData,
                selectedProduct,
                orderDate: new Date()
            };
            await  firebase.database().ref().update(updates);
            this.props.history.push('/orders');
        },
        "prefill": {
            "name": currentUser.displayName,
            "email": currentUser.email
        },
        "notes": {
            "address": currentUser.displayName
        },
        "theme": {
            "color": "#F37254"
        }
    };
    const instance = new window.Razorpay(options);
    instance.open();
    }


    render() {
        const { selectedProduct } = this.state;
        console.log('selectedProduct', selectedProduct)
        return (
            <div>
                <Header search="true" />
                <div className="container my-5">
                    <Row>
                        <Col md="2" ></Col>
                        <Col md="5" style={{ width: "456px", height: "303px" }}>

                            <img className="text-center" style={{ width: "30%", margin: "0px auto" }} src={selectedProduct && selectedProduct.imgUrl} alt="" />


                        </Col>
                        <Col md="5">
                            <h3>Seller description</h3>

                            <Row className="productDesc">
                                <Col className="col-sm-6">
                                    <div>Price</div>
                                    <div>Model</div>
                                    <div>Rating</div>
                                </Col>
                                <Col className="col-sm-6">
                                    <div>{selectedProduct && selectedProduct.price}</div>
                                    <div>{selectedProduct && selectedProduct.name}</div>
                                    <div>{selectedProduct && selectedProduct.rating}</div>
                                </Col>

                            </Row>

                            <div>


                                <div className="mt-2">
                                    <Button onClick={() => this.openCheckout()} color="primary" style={{width:"100%"}} size="sm">Buy</Button>

                                </div>
                            </div>


                        </Col>
                    </Row>
                    <div className="my-3">
                        <h3>Details</h3>
                        <Row>
                            <Col sm="4">Brand</Col>
                            <Col sm="8">{selectedProduct && selectedProduct.name}</Col>
                        </Row>

                        <hr />
                    </div>
                </div>

            </div>
        );
    }
}

export default ProductDetail;